const initialState = {
  nama: "",
  nopeg: "",
  role: "",
  idClient: "",
  idCabang: "",
  idUser: "",
  kodeUser: "",
  fullname: "",
  email: "",
  koordinator: "",
  jabatan: "",
  akses: [],
};

const authReducer = (state = initialState, action) => {
  let { type, data } = action;
  switch (type) {
    case "SET_IDENTITY":
      return {
        ...state,
        nama: data.nama,
        nopeg: data.nopeg,
        role: data.role,
        idClient: data.idClient,
        idCabang: data.idCabang,
        idUser: data.idUser,
        kodeUser: data.kodeUser,
        jabatan: data.jabatan,
        akses: data.akses,
      };
    case "SET_UBAH_PASSWORD":
      return {
        ...state,
        nopeg: data.nopeg,
        role: data.role,
      };
    case "SET_IDENTITY_KOORDINATOR":
      return {
        ...state,
        nama: data.nama,
        nopeg: data.nopeg,
        role: data.role,
        idClient: data.idClient,
        idCabang: data.idCabang,
        idUser: data.idUser,
        kodeUser: data.kodeUser,
        jabatan: data.jabatan,
      };
    case "SET_IDENTITY_KOORDINATOR_PRODUKTIF":
      return {
        ...state,
        nama: data.nama,
        nopeg: data.nopeg,
        role: data.role,
        idClient: data.idClient,
        idCabang: data.idCabang,
        idUser: data.idUser,
        kodeUser: data.kodeUser,
        jabatan: data.jabatan,
      };
    default:
      return state;
  }
};

export default authReducer;
